export default __webpack_public_path__ + "ad820595a86c90e6eac0568dce673f60.png";